export enum RadioPanelGroupTheme {
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
}
